<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Datatable from "@/router/layouts/table-datatable";
import Pagination from "@/router/layouts/table-pagination";
import _ from "lodash";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Report Analisa Soal",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Datatable, Pagination },
  data() {
    let sortOrders = []; // select sortOrder
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "-",
      },
      {
        width: "auto",
        label: "Kode Kompetensi",
        name: "kode_kompetensi",
      },
      {
        width: "auto",
        label: "Kompetensi",
        name: "nama_kompetensi",
      },
      {
        width: "auto",
        label: "Level",
        name: "level_kompetensi_idlevel_kompetensi",
      },
      {
        width: "auto",
        label: "Jenis Soal",
        name: "jenis_soal",
      },
      {
        width: "auto",
        label: "Jumlah Butir Soal",
        name: "jumlah_soal_dalam_kompetensi",
      },
      {
        width: "auto",
        label: "Soal Sudah Keluar",
        name: "jumlah_soal_yang_muncul",
      },
      {
        width: "auto",
        label: "Soal Belum Keluar",
        name: "jumlah_soal_belum_keluar",
      },
      {
        width: "auto",
        label: "Pertanyaan",
        name: "pertanyaan",
      },
      {
        width: "auto",
        label: "Dikerjakan Peserta",
        name: "dikerjakan",
      },
      {
        width: "auto",
        label: "Jawaban Benar",
        name: "soal_benar",
      },
      {
        width: "auto",
        label: "Jawaban Salah",
        name: "soal_salah",
      },
      {
        width: "auto",
        label: "% Benar",
        name: "persentase",
      },
      {
        width: "auto",
        label: "Keterangan",
        name: "keterangan",
      },
    ];
    const menu = "Report Analisa Soal";

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: menu,
      showModal: false,
      titleModal: "",
      typeModal: "add",
      loadingTable: false,
      columns: columns,
      sortKey: "idtreshold_analisa_soal",
      sortOrders: sortOrders,
      currentTablePage: "",
      tableData: [],
      tableFilter: {
        page: 1,
        draw: 0,
        per_page: 10,
        search: "",
        column: "idkompetensi",
        dir: "asc",
        kode_kompetensi: null,
        idkompetensi: null,
        level_kompetensi_idlevel_kompetensi: null,
        jenis_soal: null,
        persentase: null,
        keterangan: null,
        filter_status: "all", // untuk filtering data
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      filterKodeKompetensi: null,
      filterKompetensi: null,
      filterLevel: null,
      filterJenisSoal: null,
      optionFilterKodeKompetensi: [],
      optionFilterKompetensi: [],
      optionFilterLevel: [],
      optionFilterJenisSoal: [
        { jenis_soal: "Pilihan Ganda" },
        { jenis_soal: "Benar Salah" },
        { jenis_soal: "Menjodohkan" },
        { jenis_soal: "Text" },
      ],
    };
  },
  methods: {
    async searchKompetensi(search, loading) {
      if (search.length) {
        loading(true);
        await this.getKompetensiFilter(search, loading);
      }
    },
    async getKompetensiFilter(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/kompetensi/all",
          {
            params: {
              search: search,
              limit: 10,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.optionFilterKompetensi = response.data.data;
          if (loading) loading(false);
        });
    },
    async searchKodeKompetensi(search, loading) {
      if (search.length) {
        loading(true);
        await this.getKodeKompetensiFilter(search, loading);
      }
    },
    async getKodeKompetensiFilter(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/kompetensi/all",
          {
            params: {
              search: search,
              limit: 10,
              col: "kode_kompetensi",
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.optionFilterKodeKompetensi = response.data.data;
          if (loading) loading(false);
        });
    },
    getLevelKompetensi() {
      axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "master/level-kompetensi",
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.optionFilterLevel = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async getDataTable(resetPage = true) {
      this.tableFilter.page = resetPage ? 1 : this.tableFilter.page;
      this.loadingTable = true;
      this.tableData = [];
      const config = {
        method: "get",
        url: `${process.env.VUE_APP_BACKEND_URL_VERSION}report-analisa-soal`,
        params: this.tableFilter,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
      await axios(config)
        .then((response) => {
          if (response.data.meta.code == 200) {
            this.tableData = response.data.data.data;
            this.currentTablePage = response.data.data.current_page;
            this.loadingTable = false;
            this.configPagination(response.data.data);
          } else {
            this.loadingTable = false;
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.data.meta.message,
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          this.loadingTable = false;
        });
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] == value);
    },
    toPage(url) {
      let link = new URLSearchParams(url);
      this.tableFilter.page = link.get("page");
      // this.tableFilter.per_page = link.get('per_page');
      this.getDataTable(false);
    },
    exportData() {
      const filteredParams = Object.fromEntries(
        Object.entries(this.tableFilter).filter(
          ([key, value]) => key !== null && value !== null
        )
      );
      let params = new URLSearchParams(filteredParams).toString();
      window.open(
        process.env.VUE_APP_BACKEND_URL_VERSION +
          "export-excel/report-analisa-soal?" +
          params
      );
    },
  },
  mounted() {
    this.getDataTable();
    this.getKodeKompetensiFilter();
    this.getKompetensiFilter();
    this.getLevelKompetensi();
    this.filterData = _.debounce(this.getDataTable.bind(this), 500);
    this.filterKodeKompetensi = _.debounce(
      this.searchKodeKompetensi.bind(this),
      500
    );
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 d-flex justify-content-between">
                <h4 class="card-title">Report Analisa Soal</h4>
                <button class="btn btn-success btn-sm" @click="exportData()">
                  <i class="fa fa-file-excel"></i> Export Excel
                </button>
              </div>
              <div class="col-lg-12">
                <hr />
                <div class="row">
                  <div class="col-md-4 mb-2">
                    <label for="filterKodeKompetensi" class="form-label">
                      Kode Kompetensi
                    </label>
                    <v-select
                      id="parent_menu"
                      class="style-chooser"
                      :options="optionFilterKodeKompetensi"
                      :reduce="(item) => item.kode_kompetensi"
                      label="kode_kompetensi"
                      v-model="tableFilter.kode_kompetensi"
                      placeholder="Filter Kode Kompetensi"
                      @search="filterKodeKompetensi"
                      @update:modelValue="getDataTable()"
                    />
                  </div>
                  <div class="col-md-4 mb-2">
                    <label for="filterKompetensi" class="form-label">
                      Kompetensi
                    </label>
                    <v-select
                      id="parent_menu"
                      class="style-chooser"
                      :options="optionFilterKompetensi"
                      :reduce="(item) => item.nama_kompetensi"
                      label="nama_kompetensi"
                      v-model="tableFilter.idkompetensi"
                      placeholder="Filter Kompetensi"
                      @search="filterKompetensi"
                      @update:modelValue="getDataTable()"
                    />
                  </div>
                  <div class="col-md-4 mb-2">
                    <label for="filterLevel" class="form-label"> Level </label>
                    <v-select
                      id="parent_menu"
                      class="style-chooser"
                      :options="optionFilterLevel"
                      :reduce="(item) => item.idlevel_kompetensi"
                      label="nama_level"
                      v-model="tableFilter.level_kompetensi_idlevel_kompetensi"
                      placeholder="Filter Level"
                      @update:modelValue="getDataTable()"
                    />
                  </div>
                  <div class="col-md-4 mb-2">
                    <label for="filterJenisSoal" class="form-label">
                      Jenis Soal
                    </label>
                    <v-select
                      id="parent_menu"
                      class="style-chooser"
                      :options="optionFilterJenisSoal"
                      :reduce="(item) => item.jenis_soal"
                      label="jenis_soal"
                      v-model="tableFilter.jenis_soal"
                      placeholder="Filter Jenis Soal"
                      @update:modelValue="getDataTable()"
                    />
                  </div>
                  <div class="col-md-4 mb-2">
                    <label for="filterPersentase" class="form-label">
                      Pesentase
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="tableFilter.persentase"
                      placeholder="Filter Persentase"
                      @input="filterData"
                    />
                  </div>
                  <div class="col-md-4 mb-2">
                    <label for="filterKeterangan" class="form-label">
                      Keterangan
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="tableFilter.keterangan"
                      placeholder="Filter Keterangan"
                      @input="filterData"
                    />
                  </div>
                </div>
                <hr />
              </div>
              <div class="col-md-12 mb-2">
                <div class="row">
                  <div class="col-md-4">
                    <table>
                      <tr>
                        <td>Show</td>
                        <td>
                          <select
                            class="form-control form-control-sm"
                            v-model="tableFilter.per_page"
                            @change="getDataTable()"
                          >
                            <option value="10" selected>10</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="200">200</option>
                            <option value="500">500</option>
                          </select>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <datatable
                :columns="columns"
                :sortKey="sortKey"
                :sortOrders="sortOrders"
                @sort="sortBy"
              >
                <tbody>
                  <tr v-if="loadingTable">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i> Loading...
                    </td>
                  </tr>
                  <tr v-else-if="tableData.length == 0">
                    <td colspan="99" class="text-center">
                      Data tidak tersedia
                    </td>
                  </tr>
                  <tr v-else v-for="(row, key) in tableData" :key="key">
                    <td>
                      <span v-if="key + 1 == 10">
                        {{ currentTablePage }}0.
                      </span>
                      <span v-else>
                        {{
                          currentTablePage - 1 != 0
                            ? currentTablePage - 1 + `${key + 1}`
                            : `${key + 1}`
                        }}.
                      </span>
                    </td>
                    <td>
                      {{ row.kode_kompetensi }}
                    </td>
                    <td>
                      {{ row.nama_kompetensi }}
                    </td>
                    <td>
                      {{ row.level_kompetensi_idlevel_kompetensi }}
                    </td>
                    <td>
                      {{ row.jenis_soal }}
                    </td>
                    <td>
                      {{ row.jumlah_soal_dalam_kompetensi }}
                    </td>
                    <td>
                      {{ row.jumlah_soal_yang_muncul }}
                    </td>
                    <td>
                      {{ row.jumlah_soal_belum_keluar }}
                    </td>
                    <td>
                      {{ row.pertanyaan }}
                    </td>
                    <td>
                      {{ row.dikerjakan }}
                    </td>
                    <td>
                      {{ row.soal_benar }}
                    </td>
                    <td>
                      {{ row.soal_salah }}
                    </td>
                    <td>
                      {{ row.persentase }}
                    </td>
                    <td>
                      {{ row.keterangan }}
                    </td>
                  </tr>
                </tbody>
              </datatable>
            </div>
            <pagination :pagination="pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
